/**
 * 불러톡 대화방 (/m/chat) — 화면 본체는 공유 하네스 $j.F.Chat (값은 blade #chat-data).
 * 여기서는 그 하네스를 띄우고, /m 전용 헤더(#talkHolder)의 ← 를 잇는다.
 */
export default class Chat {
    initialize() {
        $j.F.Chat.init();
        $('#ch-back').on('click', () => history.back());
    }
}
